import { StyleSheet } from 'aphrodite';
import { destructive, grayIconFill } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		marginTop: 10,
		paddingBottom: 20,
	},
	formGrid: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	input: {
		height: 31,
		width: '100%',
	},
	row: {
		display: 'flex',
		gap: 12,
	},
	fieldGroup: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	fieldLabel: {
		fontSize: 12,
		fontWeight: 600,
		marginTop: 4,
	},
	chargifyIndicator: {
		fontSize: 11,
		color: grayIconFill,
		fontStyle: 'italic',
	},
	required: {
		color: destructive,
	},
	actions: {
		marginTop: 4,
	},
});
